import { api } from "../../../../../utility/AxiosInceptor";
import React, { useEffect } from "react";
import { useFormik } from "formik";
import { InputText } from "primereact/inputtext";

import { useState } from "react";
import "../css/advance_search.css";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import DisplayAdvanceSearchApiResponse from "./component/search_result";
import { InputMask } from "primereact/inputmask";
import CommonLoaderBlue from "../../billingModel/billingmodel_configurations/Loaders/components/Loader/LoaderBlue";
const AdvanceSearch = ({ setSearchBy }) => {
  const loginRes = localStorage.getItem("userData");
  const parseLoginRes = JSON.parse(loginRes);
  const [isLoading, setIsLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [carrierholder, setCarrier] = useState([]);
  const data = localStorage.getItem("permissions");
  const parseData = JSON.parse(data);
  const formik = useFormik({
    initialValues: {
      contact: "",
      firstName: "",
      lastName: "",
      email: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      DOB: "",
      SSN: "",
      esnId: "",
      status: "",
      carrier: "",
      esn: "",
      IMEI: "",
      applicationId: "",
      subscriberId: "",
    },
    onSubmit: async (values, actions) => {
      if (!isLoading) {
        const dataToSend = {
          contact: formik.values.contact,
          firstName: formik.values.firstName,
          lastName: formik.values.lastName,
          email: formik.values.email,
          address1: formik.values.address1,
          address2: formik.values.address2,
          city: formik.values.city,
          state: formik.values.state,
          zip: formik.values.zip,
          DOB: formik.values.DOB,
          SSN: formik.values.SSN,
          esnId: formik.values.esnId,
          status: formik.values.status,
          carrier: formik.values.carrier,
          esn: formik.values.esn,
          IMEI: formik.values.IMEI,
          applicationId: formik.values.applicationId,
          subscriberId: formik.values.subscriberId,
          permissions: parseData,
        };
        try {
          setIsLoading(true);
          const response = await api.post(
            `/api/web/search/advancesearch?userId=${parseLoginRes._id}`,
            dataToSend
          );
          if (response?.status === 200 || response?.status === 201) {
            setSearchData(response?.data);
            setIsLoading(false);
          } else {
            setIsLoading(false);
          }
        } catch (error) {
          setIsLoading(false);
        }
      }
    },
  });
  //Account Type
  /* const optionsForAccountType = [ 
         {label:"--Select--",value:""},
        { label: "ACP", value: "acp" },
        { label: "Non ACP", value: "nonAcp" },
    ];*/
  //Status
  const optionsForStatus = [
    { label: "Status", value: "" },
    { label: "Active", value: "active" },
    { label: "Inactive", value: "inactive" },
    { label: "Rejected", value: "rejected" },
    { label: "Suspend", value: "suspend" },
    { label: "Prospect", value: "prospect" },
    { label: "Dispatched", value: "dispatched" },
  ];
  useEffect(() => {
    api
      .get(`/api/web/carrier/all`)
      .then((res) => {
        let carrierholder = [{ label: "Carrier", value: "" }];
        for (let i = 0; i < res.data.data.length; i++) {
          const obj = {};
          obj.label = res.data.data[i].name;
          obj.value = obj.label;
          carrierholder.push(obj);
        }

        setCarrier(carrierholder);
      })
      .catch(() => {});
  }, []);
  return (
    <div className="advance-searchmaincontainer">
      <div className=" advance-searchmain">
        <form className="wrapper-advancesearch" onSubmit={formik.handleSubmit}>
          <h1 className="heading">Subscriber Information Lookup </h1>
          <p style={{ marginTop: "1.2rem" }}>
            Perform detailed searches by phone number, personal details, or
            device information. Multiple filters improve search precision.
          </p>

          <div
            className="flex flex-column justify-content-left"
            style={{ height: "30.8rem", marginTop: "2.4rem" }}
          >
            <div className="flex" style={{ marginTop: "1.2rem" }}>
              <div className="field-width2 input_container">
                <label className="field_label">Contact</label>
                <InputText
                  id="contact"
                  keyfilter="pint"
                  value={formik.values.contact}
                  onChange={formik.handleChange}
                  className="input_box w-full"
                  placeHolder="Phone Number"
                />
              </div>

              <div className="input_container">
                <label className="field_label ">Address 1</label>
                <InputText
                  id="address1"
                  value={formik.values.address1}
                  onChange={formik.handleChange}
                  className="input_box w-full"
                  placeHolder="Street Address"
                />
              </div>

              <div className="input_container">
                <label className="field_label">Address 2</label>
                <InputText
                  id="address2"
                  value={formik.values.address2}
                  onChange={formik.handleChange}
                  className="w-full input_box "
                  placeHolder="Apartment or Unit"
                />
              </div>
            </div>
            <div className="flex" style={{ marginTop: "1.2rem" }}>
              <div className="input_container">
                <label className="field_label">ESN ID</label>
                <InputText
                  id="esnId"
                  value={formik.values.esnId}
                  onChange={formik.handleChange}
                  className="input_box w-full"
                  placeHolder="Account Number"
                />
              </div>

              {/*<div className="input_container">
                        <InputText
                            // id="phoneNumber"
                            // value={formik.values.phoneNumber}  
                            onChange={formik.handleChange}
                            placeHolder="Enroll Id"
                            className="input_box w-full"
                        />
                    </div>  */}
              <div className="input_container">
                <label className="field_label">City</label>
                <InputText
                  id="city"
                  className="input_box w-full"
                  value={formik.values.city}
                  onChange={formik.handleChange}
                  placeHolder="City"
                />
              </div>
              <div className="input_container">
                <label className="field_label">First Name</label>
                <InputText
                  id="firstName"
                  className="input_box w-full"
                  value={formik.values.firstName}
                  onChange={formik.handleChange}
                  placeHolder="First Name"
                />
              </div>
            </div>

            <div className="flex" style={{ marginTop: "1.2rem" }}>
              <div className="input_container">
                <label className="field_label">State</label>
                <InputText
                  id="state"
                  className="input_box w-full"
                  value={formik.values.state}
                  onChange={formik.handleChange}
                  placeHolder="State"
                />
              </div>
              <div className="input_container">
                <label className="field_label">Last Name</label>
                <InputText
                  id="lastName"
                  className="input_box w-full"
                  value={formik.values.lastName}
                  onChange={formik.handleChange}
                  placeHolder="Last Name"
                />
              </div>
              <div className="input_container">
                <label className="field_label">Zip Code</label>
                <InputText
                  id="zip"
                  className="input_box w-full"
                  value={formik.values.zip}
                  onChange={formik.handleChange}
                  placeHolder="Zip"
                />
              </div>
            </div>
            <div className="flex" style={{ marginTop: "1.2rem" }}>
              <div className="input_container">
                <label className="field_label">Email</label>
                <InputText
                  id="email"
                  className="input_box w-full"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  placeHolder="Email"
                />
              </div>
              <div className="input_container">
                <label className="field_label">SSN</label>
                <InputText
                  id="SSN"
                  keyfilter="pint"
                  className="input_box w-full"
                  value={formik.values.SSN}
                  onChange={formik.handleChange}
                  placeHolder="SSN"
                />
              </div>

              <div className="input_container">
                <label className="field_label">DOB</label>
                <InputMask
                  id="DOB"
                  mask="99-99-9999"
                  placeholder="MM-DD-YYYY"
                  className="input_box w-full"
                  value={formik.values.DOB}
                  onChange={formik.handleChange}
                />
              </div>
            </div>
            <div className="flex" style={{ marginTop: "1.2rem" }}>
              <div className="input_container">
                <label className="field_label">Status</label>
                <Dropdown
                  id="status"
                  value={formik.values.status}
                  placeholder="Status"
                  options={optionsForStatus}
                  onChange={formik.handleChange}
                  className="input_box w-full"
                />
              </div>
              <div className="input_container">
                <label className="field_label">ESN</label>
                <InputText
                  id="esn"
                  keyfilter="pint"
                  className="input_box w-full"
                  value={formik.values.esn}
                  onChange={formik.handleChange}
                  placeHolder="SIM/ESN"
                />
              </div>
              <div className="input_container">
                <label className="field_label">Carrier</label>
                <Dropdown
                  id="carrier"
                  value={formik.values.carrier}
                  placeholder="Carrier"
                  options={carrierholder}
                  className="input_box w-full"
                  onChange={(e) => {
                    formik.setFieldValue("carrier", e.value);
                    formik.handleChange(e);
                  }}
                />
              </div>
            </div>
            <div className="flex" style={{ marginTop: "1.2rem" }}>
              <div className="input_container">
                <label className="field_label">IMEI</label>
                <InputText
                  id="IMEI"
                  className="input_box w-full"
                  keyfilter="pint"
                  value={formik.values.IMEI}
                  onChange={formik.handleChange}
                  placeHolder="IMEI"
                />
              </div>
              <div className="input_container">
                <label className="field_label">Subscriber ID</label>
                <InputText
                  id="subscriberId"
                  className="input_box w-full"
                  value={formik.values.subscriberId}
                  onChange={formik.handleChange}
                  placeHolder="NLAD Subscriber Id"
                />
              </div>
              <div className="input_container">
                <label className="field_label">NV Application ID</label>
                <InputText
                  id="applicationId"
                  className="input_box w-full"
                  value={formik.values.applicationId}
                  onChange={formik.handleChange}
                  placeHolder="NV Application Id"
                />
              </div>
            </div>
            <div
              style={{ marginTop: "1.2rem" }}
              className="w-full flex flex-wrap flex-row justify-content-end items-center"
            >
              <Button
                label={
                  isLoading ? (
                    <div className="w-full flex flex-wrap flex-row justify-content-center">
                      <CommonLoaderBlue customSize={14} color="white" />{" "}
                    </div>
                  ) : (
                    "Search"
                  )
                }
                className="nextbtn"
              />
            </div>
          </div>
          {
            <DisplayAdvanceSearchApiResponse
              isLoading={isLoading}
              searchData={searchData}
              setSearchBy={setSearchBy}
            />
          }
        </form>
      </div>
    </div>
  );
};

export default AdvanceSearch;
